import type { MasterDataVehicleListPageProps } from "@/pages/master-data-vehicle-list/model";
import { MobileVehicleListItem } from "@/pages/master-data-vehicle-list/ui/mobile/vehicle-list/vehicle-list-item";
import type { LoadableData } from "@/shared/lib/loadable";
import { Box, Stack } from "@mui/material";
import { useMemo } from "react";

type Props = {
  vehicles: LoadableData<MasterDataVehicleListPageProps["vehicles"]>;
  onVehicleClick: (vehicleId: number) => void;
};

export const MobileVehicleList: React.FC<Props> = (props) => {
  const sortedVehicles = useMemo(() => {
    return props.vehicles.data.sort((a, b) => {
      return b.id - a.id;
    });
  }, [props.vehicles.data]);

  return (
    <Stack
      direction="column"
      gap={1}
      px={1}
      py={2}
      sx={{
        backgroundColor: "grey.50",
        border: "1px solid #E4E5E5",
        borderWidth: "1px 0",
      }}
    >
      {sortedVehicles.map((vehicle) => (
        <Box
          key={vehicle.id}
          sx={{
            backgrounColor: "white",
            boxShadow: "0px 1px 10px 0px #0000001A",
            borderRadius: "18px",
            border: "1px solid #E4E5E5",
            p: 1.5,
          }}
        >
          <MobileVehicleListItem
            vehicle={vehicle}
            onVehicleClick={props.onVehicleClick}
          />
        </Box>
      ))}
    </Stack>
  );
};
